import { DEFAULT_THEME } from '../../configs/theme'

export const formatByTheme = (data, theme = DEFAULT_THEME, others) => {
  if (theme === DEFAULT_THEME) {
    return data
  }

  return others[theme]
}
